import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';

@Component({
    selector: 'click-to-copy',
    templateUrl: './click-to-copy.component.html',
    styleUrls: ['./click-to-copy.component.scss'],
})
export class ClickToCopyComponent implements OnInit
{
    @ViewChild('wrappedContent') content;

    @Output()
    public triggered: EventEmitter<boolean> = new EventEmitter<boolean>();

    constructor() {
    }

    ngOnInit() {
    }

    copyContent() {
        const input = document.createElement('textarea');
        input.style.position = 'fixed';
        input.style.left = '-99999px';
        input.value = this.content.nativeElement.text.trim();
        document.body.appendChild(input);
        input.focus();
        input.select();
        try {
            const success = document.execCommand('copy');
            this.triggered.emit(success);
        } catch (err) {
            this.triggered.emit(false);
        }
        document.body.removeChild(input);
    }
}
